// START GENAI
import { Component, h, Prop, State } from '@stencil/core';
import { getDataFromPropString } from '../../utils/utils';

@Component({
  tag: 'vs-content-bundle',
  styleUrl: './_vs-content-bundle.scss',
})
export class ContentBundle {
  @Prop() contentBundleData: string | JSON;
  @Prop() displayPublishDate: string = 'yes';
  @Prop() layout: string = 'content-library';
  @Prop() playAriaLabel = 'Play';
  @Prop() headerId: string = 'contentLibraryBundleHeader';
  @Prop() needextraAria = true;
  @State() allProps = {};
  ctas: [HTMLDivElement];

  componentWillLoad() {
    this.allProps = typeof this.contentBundleData === 'string' ? getDataFromPropString(this.contentBundleData) : this.contentBundleData;
    this.ctas = this.renderCTAs(this.allProps);
  }

  componentWillUpdate() {
    this.allProps = typeof this.contentBundleData === 'string' ? getDataFromPropString(this.contentBundleData) : this.contentBundleData;
    this.ctas = this.renderCTAs(this.allProps);
  }

  renderCTAs = (allProps: {}) => {
    return allProps['ctas'].map(function (ctaItem) {
      return (
        <div class="vs-bundle-cta-item" key={ctaItem.uniqueId}>
          <vs-link
            link-aria-label={ctaItem.ctaLinkAriaLabel}
            button-color={ctaItem.ctaButtonColor}
            link-conversion={ctaItem.ctaConversionType}
            link-type={ctaItem.ctaLinkType}
            link-style={ctaItem.ctaStyle}
            has-dark-bg="no"
            link-target={ctaItem.ctaLinkTarget}
            link-text={ctaItem.ctaTitle}
            img-path={ctaItem.ctaVideoImagePath}
            video-title={ctaItem.ctaVideoTitle}
            video-url={ctaItem.ctaVideoUrl}
            link-val={ctaItem.ctaLink}
            modal-target={ctaItem.ctaUniqueId}
            is-no-follow={ctaItem?.ctaNoFollow}
          ></vs-link>
        </div>
      );
    });
  };

  render() {
    return (
      <div
        class="vs-content-bundle"
        data-layout={this.layout}
        data-view-publish-date={this.displayPublishDate}
        {...(this.needextraAria ? { 'aria-atomic': 'false', 'aria-live': 'polite' } : {})}
      >
        <vs-content-bundle-media
          img-path={this.allProps['desktopImagePath']}
          img-alt-text={this.allProps['desktopAltText']}
          has-video={this.allProps['video']}
          video-url={this.allProps['youtubeVideoUrl']}
          video-title={this.allProps['videoTitle']}
          play-btn-color={this.allProps['videoPlayButtonColor']}
          video-layout={this.layout}
          video-play-aria-value={this.playAriaLabel}
        ></vs-content-bundle-media>

        <vs-content-bundle-text
          publish-date={this.allProps['publishDate']}
          header-style={this.displayPublishDate === 'yes' || this.allProps['bodyCopy'].length > 0 || this.allProps['ctas'].length > 0 ? this.allProps['headerStyle'] : 'strong'}
          header-text={this.allProps['headerText']}
          body-text={this.allProps['bodyCopy']}
          header-id={this.headerId}
          eyebrow-text={this.allProps['eyebrowText']}
        ></vs-content-bundle-text>

        <div class="vs-content-bundle-cta">{this.ctas}</div>
      </div>
    );
  }
}